import React, { useEffect, useRef, useState } from 'react'
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import listPlugin from '@fullcalendar/list'
import basicWeek from '@fullcalendar/list'
import timeGridPlugin from '@fullcalendar/timegrid'
import dayGridWeek from '@fullcalendar/daygrid'
import 'bootstrap/dist/css/bootstrap.css';
import bootstrapPlugin from '@fullcalendar/bootstrap'
import 'bootswatch/dist/lux/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.css'
import './styles.css';
import { Button, Checkbox, DatePicker, Radio, Select, Spin } from 'antd';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import api from '../../services/api';
import ptBr from 'antd/es/date-picker/locale/pt_BR';
import { message } from 'antd';
import moment from 'moment';
import * as PermissaoAction from '../../redux/actions/permissao';
import * as AgendaAction from '../../redux/actions/agendaActions';
import { useHistory } from 'react-router-dom'
import { ArrowDown, DadosCadastrais, IconReturn, IconFirst, Impressao, Mais } from '../../assets/Icones/icones'
import { municipioService } from '../../services/Municipios-Service/municipios-service'
import { Agendamento } from '../../models/agendamento'
import { loginService } from '../../services/Login-Service/login-service'

interface CalendarioAgendamentoProps {
    setAgendamentos: any,
    setAgendamentoModal: any,
    setAgendamentoInfoModal: any,
    setAgendamentosPorPeriodoModal: any,
    setPreCadastroModal: any,
    setAgendadosModal: any,
    clearAgendamentos: any,
    removeAll: any,
    setRealizarAtendimento: any,
    modalStatus: any,
    permissao?: any,
    agenda: any
}

const CalendarioAgendamento: React.FC<CalendarioAgendamentoProps> = (prop) => {

    const [loadCalendar, setLoadCalendar] = React.useState(false);
    const [startDate, setStartDate] = React.useState<any>();
    const [endDate, setEndDate] = React.useState<any>();
    const [view, setView] = useState<"day" | "week" | "month">("month")
    const [municipios, setMunicipios] = useState<any>();
    const [events, setEvents] = useState<any[]>();
    const [municipioAtual, setMunicipioAtual] = useState();
    const [filtro, setFiltro] = useState<any[]>([])
    const [radioGroupDateValue, setRadioGroupDateValue] = useState<"dia" | "mes" | "anos">("mes")
    let event: any;
    var eventsPush: any[] = [];
    const [Cancelado, setCancelado] = useState(0);
    let countCancelado = 0;
    const [Aberto, setAberto] = useState(0);
    const [Retorno, setRetorno] = useState(0);
    let countRetorno = 0;
    const calendarRef = useRef<FullCalendar>(null);
    let countAberto = 0;
    const [Realizado, setRealizado] = useState(0);
    let countRealizado = 0;
    const [Pausado, setPausado] = useState(0);
    const history = useHistory()

    useEffect(() => {
        handleMunicipio();
        var start = sessionStorage.getItem('StartDate')
        var end = sessionStorage.getItem('EndDate')
        if (prop.modalStatus[0].visibleAgendamento === false || prop.modalStatus[0].visibleAgendamentoInfo === false) {
            if (startDate !== undefined && endDate !== undefined) {
                getAgendamentos(startDate, endDate);
            }
            else {
                getAgendamentos(start, end);
            }
        }
        handleHeight()

    }, [prop.modalStatus[0].visibleAgendamento, prop.modalStatus[0].visibleAgendamentoInfo]);

    useEffect(() => () => {
        var start = sessionStorage.getItem('StartDate')
        var end = sessionStorage.getItem('EndDate')
        prop.setAgendamentoInfoModal(null)
        prop.setAgendamentoModal(null)
        if (startDate !== undefined && endDate !== undefined)
            prop.clearAgendamentos(startDate, endDate)
        else
            prop.clearAgendamentos(start, end)
    }, [])

    const getAgendamentosDataSelecionada = (dataSelecionada: Date | undefined) => {
        if (dataSelecionada !== undefined) {
            events?.sort((a, b) => {
                if (moment(new Date(a.start)).isSame(moment(new Date(b.start)))) {
                    return a.title < b.title ? -1 : 1;
                } else {
                    return a.start < b.start ? -1 : 1;
                }
            });
            return events?.filter(e => !e.feriado && new Date(e.start).getUTCDate() === dataSelecionada.getUTCDate() && new Date(e.start).getUTCMonth() === dataSelecionada.getUTCMonth() && new Date(e.start).getFullYear() === dataSelecionada.getFullYear());
        }
        return null;
    }

    const dataSelecionadaTemFeriado = (dataSelecionada: Date): boolean => {
        let feriado = null;
        feriado = events?.find(e => e.feriado && new Date(e.start).getUTCDate() === dataSelecionada.getUTCDate() && new Date(e.start).getUTCMonth() === dataSelecionada.getUTCMonth() && new Date(e.start).getFullYear() === dataSelecionada.getFullYear());
        if (feriado === undefined || !feriado.feriado) {
            return false
        } else {
            return true
        }
    }

    const dataSelecionadaTemBloqueio = () =>{

    }

    const handleMunicipio = () => {
        municipioService.getMunicipio().then((resp) => {
            setMunicipios(resp.data)
        })
    }

    const verificarAgendamentosMesAtualDoCalendario = (agendamento: Agendamento): boolean => {
        if (!agendamento)
            return false;

        let startSession = sessionStorage.getItem('StartDate');
        let start = moment(startSession).add(1, 'month').startOf('month').format()
        let end = moment(start).endOf('month').format();

        if (!start || !end)
            return false

        return moment(agendamento.dataHoraInicio).format() >= start && moment(agendamento.dataHoraInicio).format() <= end;
    }

    const gerarLegenda = (agendamentos: any) => {
        const classNamesMap: any = {
            Cancelado: 'canceladoClass',
            Aberto: 'abertoClass',
            Realizado: 'realizadoClass',
        };
        eventsPush = [];
        setEvents([]);
        setAberto(0)
        setCancelado(0)
        setRealizado(0)
        setPausado(0)
        setRetorno(0)
        countCancelado = 0
        countAberto = 0
        countRealizado = 0
        countRetorno = 0
        agendamentos.map((a: Agendamento) => {
            let classText, color: string = ''
            classText = classNamesMap[a?.situacao];

            const calendarApi = calendarRef?.current?.getApi();
            const currentView = calendarApi?.view.type;

            if (verificarAgendamentosMesAtualDoCalendario(a) || currentView != 'dayGridMonth') {
                if (a.retorno) {
                    ++countRetorno
                    setRetorno(countRetorno)
                }

                if (a.situacao === "Cancelado") {
                    if (countCancelado === 0) {
                        countCancelado = 1;
                    } else {
                        countCancelado++;
                    }
                    setCancelado(countCancelado);
                } else if (a.situacao === "Aberto") {
                    if (countAberto === 0) {
                        countAberto = 1;
                    } else {
                        countAberto++;
                    }
                    setAberto(countAberto);
                } else if (a.situacao === "Realizado") {
                    if (countRealizado === 0) {
                        countRealizado = 1;
                    } else {
                        countRealizado++;
                    }
                    setRealizado(countRealizado);
                }
            }
            
            if (a?.feriado) {
                eventsPush.push(a);            
            }
            else if(a?.bloqueio){
                eventsPush.push(a);
            }          
            else {
                event = {
                    id: a?.agendamentoID,
                    start: a?.dataHoraInicio,
                    end: a?.dataHoraFinal,
                    title: a?.nome.toLowerCase(),
                    agendamento: a,
                    backgroundColor: color,
                    borderColor: color,
                    classNames: classText,
                    textColor: "rgba(0, 32, 64, 1)",
                }
                eventsPush.push(event)
            }
        })
    }

    const handleMunicipioChange = (value: any) => {
        prop.removeAll();
        setMunicipioAtual(value)
        getAgendamentos(startDate, endDate, value)
    };

    const getAgendamentos = async (start: any, end: any, municipio?: any) => {
        eventsPush = [];
        let retornos = 0;
        setEvents([]);
        setLoadCalendar(true);
        let apiUrl = `Agendamento/getagendamentobydata?dataInicio=${start}&dataFim=${end}`

        if (!loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "")) { 
            if (municipio == null && municipioAtual == null) {
                apiUrl += `&municipioSelecionado=${7385}`
            }
            else if (municipioAtual != null && municipio == null) {
                apiUrl += `&municipioSelecionado=${municipioAtual}`;
            }
            else {
                apiUrl += `&municipioSelecionado=${municipio}`;
            }
        }

        await api.get(apiUrl)
            .then((response) => {
                retornos = response.data.retornos
                gerarLegenda(response.data.agendamentos);
            }).finally(async() => {
                let apiUrlFeriado = `Feriado/getFeriadoAgendamento`
                let apiUrlBloqueio = `Bloqueio/getBloqueioAgendamento`
                if (municipio != null) {
                    apiUrlFeriado += `?municipioId=${municipio}`
                    apiUrlBloqueio += `?municipioId=${municipio}`
                } else if (municipioAtual != null){
                    apiUrlFeriado += `?municipioId=${municipioAtual}`
                    apiUrlBloqueio += `?municipioId=${municipioAtual}`
                }
                try{                
                await api.get(apiUrlBloqueio)
                    .then((response)=>{
                        response.data.map((a:any)=>{
                            if(a.ativo){
                                event = {
                                    id: a.bloqueioID + 'b',
                                    start: a.dataBloqueio,
                                    end: a.dataBloqueioFim,
                                    periodo: a.periodo,
                                    title: a.nome,
                                    overlap: false,
                                    bloqueio: true,
                                    classNames: "bloqueioContainer"
                                }
                                eventsPush.push(event)
                            }
                        })
                    })
                await api.get(apiUrlFeriado)
                    .then((response) => {
                        response.data.map((a: any) => {
                            if (a.ativo) {
                                let color: string = "#080707";
                                event = {
                                    id: a.feriadoID + 'f',
                                    start: a.dataInicio,
                                    end: a.dataFim,
                                    title: a.nome,
                                    color: color,
                                    backGroundColor: color,
                                    overlap: false,
                                    display: 'background',
                                    feriado: true,
                                    allDay: true,
                                    classNames: "feriado"
                                }
                                eventsPush.push(event)
                            }
                        })
                    
                    })
                    .catch((err) => {
                        message.error('Falha na requisição')
                        setLoadCalendar(false);
                    });
                }finally{
                    setEvents(eventsPush);
                    prop.setAgendamentos(eventsPush, start, end, retornos);
                    setLoadCalendar(false);
                }
                
            })
            .catch((err) => {
                message.error('Falha na requisição')
            });
    }

    const handlePrev = () => {
        if (calendarRef.current) {
            calendarRef.current?.getApi()?.prev();
        }
    };

    const handleNext = () => {
        if (calendarRef.current) {
            calendarRef.current?.getApi()?.next();
        }
    };

    const handleToday = () => {
        if (calendarRef.current) {
            calendarRef.current?.getApi()?.setOption('slotLabelFormat', {
                hour: 'numeric',
                minute: '2-digit',
                omitZeroMinute: false
            });
            calendarRef.current?.getApi()?.today();

        }
    };


    const handleDay = () => {
        if (calendarRef.current) {
            calendarRef.current?.getApi()?.changeView('dayGridDay')
            setView("day")
        }
    }

    const handleWeek = () => {
        if (calendarRef.current) {
            calendarRef.current?.getApi()?.changeView('dayGridWeek')
            setView("week")

        }
    }

    const handleMonth = () => {
        if (calendarRef.current) {
            calendarRef.current?.getApi()?.changeView('dayGridMonth')
            setView("month")
        }
    }

    const moreLinkContentHandler = (num: any) => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current?.getApi();
            const currentView = calendarApi.view.type;
            if ((currentView === 'dayGridMonth'))
                return <>
                    <div className="moreLink"> <ArrowDown /> {num.num} mais </div>
                </>
            else
                return false
        }
    };

    const maxEventsView = () => {
        if (calendarRef.current) {
            const calendarApi = calendarRef?.current?.getApi();
            const currentView = calendarApi?.view.type;
            if ((currentView === 'dayGridMonth')) {
                if (window.screen.height >= 900) {
                    return 3
                }
                else {
                    return 2
                }
            }
            else
                return false
        }
    }

    const setEspecificDate = (date: any) => {
        let obj = moment(date._d).format('YYYY-MM-DD')
        if (calendarRef.current) {
            const calendarApi = calendarRef.current?.getApi()
            calendarApi.changeView('dayGridDay')
            setView("day")
            calendarApi.gotoDate(obj)
            setRadioGroupDateValue("dia")
        }
    }

    const eventRender = ({ event }: any) => {
        let option = calendarRef.current?.getApi()?.view.type
        switch (option) {
            case "dayGridMonth":
                if (event._def.extendedProps?.feriado) {
                    return (
                        <div className="feriado">{event.title}</div>
                    )
                }
                else if (event._def.extendedProps?.bloqueio){
                    return (
                        <div className="bloqueio">{event.title} - {event._def.extendedProps.periodo} </div>
                    )
                }
                else {
                    return (
                        <>
                            {event._def.extendedProps.agendamento?.retorno ?
                                <div className="titleEvents">
                                    <div className='iconEvent'> <IconReturn /></div>
                                    <div> {moment(event._def.extendedProps.agendamento?.dataHoraInicio).format("HH:mm")}</div>
                                    <div className="titleStyle"> {event.title}</div>
                                </div>
                                :
                                <div className="titleEvents">
                                    <div className='iconEvent'> <IconFirst /></div>
                                    <div> {moment(event._def.extendedProps.agendamento?.dataHoraInicio).format("HH:mm")}</div>
                                    <div className="titleStyle"> {event.title}</div>
                                </div>
                            }
                        </>
                    )
                }
            case "dayGridWeek":
                if (event._def.extendedProps?.feriado) {
                    return (
                        <div className="feriado">{event.title}</div>
                    )
                }
                else if (event._def.extendedProps?.bloqueio){
                    return (
                        <div className="feriado">{event.title}</div>
                    )
                }
                else {
                    return (
                        <>
                            {event._def.extendedProps.agendamento?.retorno ?
                                <div className="titleEvents">
                                    <div className='weekTitle'>
                                        <div className='iconEvent'> <IconReturn /></div>
                                        <div className='timeWeek'> {moment(event._def.extendedProps.agendamento?.dataHoraInicio).format("HH:mm")}</div>
                                    </div>
                                    <div className="titleStyle"> {event.title}</div>
                                </div>
                                :
                                <div className="titleEvents">
                                    <div className='weekTitle'>
                                        <div className='iconEvent'> <IconFirst /></div>
                                        <div className='timeWeek'> {moment(event._def.extendedProps.agendamento?.dataHoraInicio).format("HH:mm")}</div>
                                    </div>
                                    <div className="titleStyle"> {event.title}</div>
                                </div>
                            }
                        </>
                    )
                }
            case "dayGridDay":
                if (event._def.extendedProps?.feriado) {
                    return (
                        <div className="feriado">{event.title}</div>
                    )
                }
                else if (event._def.extendedProps?.bloqueio){
                    return (
                        <div className="feriado">{event.title}</div>
                    )
                }
                else {
                    return (
                        <>
                            {event._def.extendedProps.agendamento?.retorno ?
                                <div className="titleEvents">
                                    <div className='iconEvent'> <IconReturn /></div>
                                    <div className="titleStyle"> {event.title}</div>
                                    <div className='timeWeek'> {moment(event._def.extendedProps.agendamento.dataHoraInicio).format("HH:mm")}</div>
                                </div>
                                :
                                <div className="titleEvents">
                                    <div className='iconEvent'> <IconFirst /></div>
                                    <div className="titleStyle"> {event.title}</div>
                                    <div className='timeWeek'> {moment(event._def.extendedProps.agendamento.dataHoraInicio).format("HH:mm")}</div>
                                </div>
                            }
                        </>
                    )
                }
        }
    }

    const handleHeight = () => {
        let screenSize = window.screen.height
        if (screenSize <= 950) {
            let tableHeight = (screenSize - 350)
            calendarRef?.current?.getApi()?.setOption('height', tableHeight)
        }
        else {
            calendarRef?.current?.getApi()?.setOption('height', 700)
        }
    }

    const handleCheckbox = (e: any, situacao: any) => {
        if (e.target.checked === true) {
            setFiltro((state: any) => {
                return [...state, situacao]
            })
        }
        else {
            setFiltro((state: any[]) => {
                return state.filter((item) => {
                    return item !== situacao
                })
            })
        }
    }

    return (
        <Spin spinning={loadCalendar}>
            <div className='home-container'>
                <div className="botaoConteudo">
                    <Button className="customButton" onClick={() => { history.push("/dados-cadastrais/consulta") }}> <DadosCadastrais />&nbsp; Dados Cadastrais </Button>
                    <Button className="customButton" onClick={() => { prop.setAgendamentosPorPeriodoModal(true) }}> <Impressao /> &nbsp;Imprimir Agendamentos </Button>
                    <div className="btnFuncDate">
                        <Button className="botaoPrev" onClick={handlePrev}> {"<"} </Button>
                        <Button className="botaoToday" onClick={handleToday}> Hoje </Button>
                        <Button className="botaoNext" onClick={handleNext}> {">"} </Button>
                    </div>
                    <Radio.Group defaultValue="mes" onChange={(e) => { setRadioGroupDateValue(e?.target?.value) }} value={radioGroupDateValue} className="btnDateStruct">
                        <Radio.Button onClick={handleDay} value="dia">Dia</Radio.Button>
                        <Radio.Button onClick={handleWeek} value="semana">Semana</Radio.Button>
                        <Radio.Button onClick={handleMonth} value="mes">Mês</Radio.Button>
                    </Radio.Group>
                    <Button className="customButton" onClick={() => {
                        prop.setAgendamentoModal(true)
                    }}><Mais />&nbsp;Criar Novo Agendamento</Button>

                </div>
                <div className='calendario'>
                    <div className="filtrosCalendario">
                        <div className='testeT'>
                            <DatePicker
                                className='datepickerAjuste'
                                getPopupContainer={triggerNode => triggerNode.parentElement!}
                                popupStyle={{ display: 'flex', width: '100%' }}
                                locale={ptBr}
                                onChange={setEspecificDate}
                                open={true}
                                placeholder='dd/mm/aaaa'
                                format="DD/MM/YYYY"
                                style={{ width: '100%', color: 'rgba(10, 10, 10, 1)', fontSize: '14px', border: '1px solid rgba(169, 174, 177, 1)', borderRadius: '6px', height: '40px' }}
                            />
                        </div>
                        {loginService.ehTecnicoMunicipal(sessionStorage.getItem('grupoID') || "") ? null :
                            <div className="municipiosAgendamento">
                                <span style={{ color: "#000", }}>Municipio de Agendamento</span>
                                <Select showSearch style={{ width: "100%" }} placeholder="Selecione o município do agendamento" onChange={handleMunicipioChange} 
                                defaultValue={7385} className="municipioOption"
                                filterOption={(input: any, option: any) => {
                                    return (option?.children ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                }                                
                                >
                                    {municipios?.map((value: any, index: number) =>
                                        <Select.Option key={index} value={value.municipioID}>{value.nome}</Select.Option>
                                    )}
                                </Select>
                            </div>
                        }
                        <div className="fieldset-legenda">
                            <h2 className="tituloFiltro">Filtros</h2>
                            <span className="linhaAzul"></span>
                            <span style={{ fontWeight: '600', color: 'rgba(10, 10, 10, 1)' }}>
                                Situação
                            </span>
                            <div className="legenda">
                                <div className="legenda-info">
                                    <Checkbox onChange={(e) => handleCheckbox(e, "Aberto")} />
                                    <div className="fc-daygrid-event-dot legendaIcon" style={{ borderColor: 'rgba(14, 153, 248, 1)' }} />
                                    <label style={{ color: 'rgba(10, 10, 10, 1)', fontWeight: '400' }}>Em Aberto ({Aberto})</label>
                                </div>
                                <div className="legenda-info">
                                    <Checkbox onChange={(e) => handleCheckbox(e, "Realizado")} />
                                    <div className="fc-daygrid-event-dot legendaIcon" style={{ borderColor: 'rgba(40, 164, 76, 1)' }} />
                                    <label style={{ color: 'rgba(10, 10, 10, 1)', fontWeight: '400' }}>Realizado ({Realizado})</label>
                                </div>
                                <div className="legenda-info">
                                    <Checkbox onChange={(e) => handleCheckbox(e, "Cancelado")} />
                                    <div className="fc-daygrid-event-dot legendaIcon" style={{ borderColor: 'rgba(218, 30, 40, 1)' }} />
                                    <label style={{ color: 'rgba(10, 10, 10, 1)', fontWeight: '400' }}>Cancelado ({Cancelado})</label>
                                </div>
                            </div>
                            <span style={{ fontWeight: '600', color: 'rgba(10, 10, 10, 1)' }}>
                                Retorno
                            </span >
                            <div className="legenda">
                                <div className="legenda-info">
                                    <IconFirst />
                                    <label style={{ color: 'rgba(10, 10, 10, 1)', fontWeight: '400' }}>Primeiro Atendimento ({(Cancelado + Realizado + Pausado + Aberto) - Retorno})</label>
                                </div>
                                <div className="legenda-info">
                                    <IconReturn />
                                    <label style={{ color: 'rgba(10, 10, 10, 1)', fontWeight: '400' }}>Retornos ({Retorno})</label>
                                </div>
                            </div>
                        </div>

                    </div>
                    <FullCalendar
                        viewClassNames={view}
                        ref={calendarRef}
                        weekends={true}
                        eventDisplay='block'
                        dragScroll={true}
                        slotEventOverlap={false}
                        moreLinkContent={moreLinkContentHandler}
                        slotMinTime="08:00:00"
                        slotMaxTime="18:00:00"
                        dayPopoverFormat={{ weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' }}
                        fixedWeekCount={false}
                        eventContent={eventRender}
                        slotLabelFormat={
                            {
                                hour: 'numeric',
                                minute: 'numeric',
                                omitZeroMinute: false,
                            }
                        }
                        dayMaxEvents={maxEventsView()}
                        datesSet={(dateInfo) => {
                            let start: any
                            let end: any
                            start = moment(dateInfo.start).startOf('day').format()
                            end = moment(dateInfo.end).startOf('day').format();
                            sessionStorage.setItem('EndDate', end);
                            sessionStorage.setItem('StartDate', start);
                            setEndDate(end);
                            setStartDate(start);
                            let agendamentosPorData = prop.agenda[0]?.agendamentos?.find((r: any) => r.dataInicio === start && r.dataFim === end);

                            if (agendamentosPorData?.agenda.length > 0) {

                                //Retorna os objetos da mesma forma que vindos da api 
                                let agenda = agendamentosPorData.agenda.map((m: any) => { return m?.agendamento !== undefined ? m.agendamento : m });
                                //Ajusta o objeto para se adequar ao calendario
                                //Calculando as legendas e os feriado
                                gerarLegenda(agenda);
                                setEvents(eventsPush);
                                
                            } else {
                                getAgendamentos(start, end);
                            }
                        }}
                        eventOverlap={true}
                        events={events?.filter((a: any) => {
                            if (a?.agendamento) {
                                if (filtro.length === 0) {
                                    return a
                                }
                                else {
                                    if (filtro.includes(a?.agendamento.situacao)) {
                                        return a
                                    }
                                }
                            }
                            else {
                                return a;
                            }
                        })}
                        eventTimeFormat={
                            {
                                hour: 'numeric',
                                minute: '2-digit',
                                omitZeroMinute: false,
                            }
                        }
                        plugins={[dayGridPlugin, listPlugin, basicWeek, dayGridWeek, timeGridPlugin, bootstrapPlugin]}
                        initialView="dayGridMonth"
                        navLinks={true}
                        allDaySlot={false}
                        locale="pt-br"
                        slotDuration="00:30"
                        timeZone="America/Campo_Grande"
                        themeSystem="bootstrap"
                        titleFormat={{
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                        }}
                        buttonText={{
                            today: "Hoje",
                            month: "Mês",
                            week: "Semana",
                            day: "Dia",
                            list: "Lista",
                        }}
                        headerToolbar={{
                            left: "",
                            center: "title",
                            right: ""
                        }}
                        navLinkDayClick={selectionInfo => {
                            
                            if (!dataSelecionadaTemFeriado(selectionInfo)) {
                                var eventsToday = getAgendamentosDataSelecionada(selectionInfo);
                                var exibeInformacoes = eventsToday?.map((e: any) => e.agendamento);
                                prop.setAgendadosModal(true, exibeInformacoes, selectionInfo);

                            }
                            else {
                                message.error("Não é possivel realizar agendamento em um Feriado.")
                            }
                        }}
                        eventClick={eventClickInfo => {
                            if (dataSelecionadaTemFeriado(eventClickInfo.event._instance?.range.start as Date)) {
                                message.error("Não é possivel realizar agendamento em um Feriado.")
                            }
                            else if(eventClickInfo.event._def.extendedProps.bloqueio){
                                message.info(eventClickInfo.event._def.title)
                                message.warning(`Existe um bloqueio no período : ${eventClickInfo.event._def.extendedProps.periodo.toLowerCase()}`)
                            } 
                            else {
                                let agendamentosDoDia = null
                                agendamentosDoDia = getAgendamentosDataSelecionada(eventClickInfo.event._instance?.range.start)

                                prop.setAgendamentoInfoModal(true, eventClickInfo.event._def.extendedProps.agendamento, agendamentosDoDia);

                            }
                        }}
                    />
                </div>
            </div>
        </Spin>
    )
}

const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    agenda: state.agendaReducer,
    permissao: state.permissao

})


const mapDispatcToProps = (dispatch: any) => bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction, AgendaAction), dispatch)

export default connect(mapStateToProps, mapDispatcToProps)(CalendarioAgendamento);